import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitch, faPatreon, faDiscord } from '@fortawesome/free-brands-svg-icons';

import login from '../util/login';

export default class AdSelf extends Component {
    render() {
        return (
            <>
                <div className="mx-3" align="center">
                    <small>{login.previous() ? 'Your Twitch sub has ended. A heartfelt thank you for your support!' : 'Enjoying the site? If you are able, I appreciate any help covering the hosting costs!'}</small>
                </div>
                <div className="mt-2 d-flex justify-content-center flex-wrap">
                    <a href="https://www.patreon.com/shoogen" target="external" className="btn btn-patreon text-nowrap mx-2"><FontAwesomeIcon icon={faPatreon} className={window.bootstrap.md.matches ? 'mr-2' : ''} />{window.bootstrap.md.matches ? 'Become a Patron' : null}</a>
                    <a href="https://twitch.tv/shoogen" target="external" className="btn btn-twitch text-nowrap mx-2"><FontAwesomeIcon icon={faTwitch} className={window.bootstrap.md.matches ? 'mr-2' : ''} />{window.bootstrap.md.matches ? 'Subscribe (Free w/ Prime)' : null}</a>
                    <a href="https://discord.gg/7Mmjxdh" target="external" className="btn btn-discord text-nowrap mx-2"><FontAwesomeIcon icon={faDiscord} className={window.bootstrap.md.matches ? 'mr-2' : ''} />{window.bootstrap.md.matches ? 'Join Our Discord' : null}</a>
                </div>
            </>
        );
    }
}